// Small CSV writer for exports. Two details matter for spreadsheets:
//  - quoting: fields with commas, quotes or line breaks are wrapped and their
//    quotes doubled, so the file always parses back to the same cells;
//  - formula injection: a cell that starts with = + - @ (or a tab/CR) is run
//    as a formula by Excel/Sheets, so a customer-controlled subject such as
//    "=HYPERLINK(...)" could do harm when staff open the export. Those cells
//    get a leading apostrophe, which spreadsheets show as plain text.
const DANGEROUS_START = /^[=+\-@\t\r]/;

export const csvCell = (value) => {
  if (value === null || value === undefined) return '';
  let text = value instanceof Date ? value.toISOString() : String(value);
  if (DANGEROUS_START.test(text) && !/^[-+]?\d+(\.\d+)?$/.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// columns: [{ label, value: (row) => any }]
export const toCsv = (rows, columns) => {
  const lines = [columns.map((c) => csvCell(c.label)).join(',')];
  rows.forEach((row) => lines.push(columns.map((c) => csvCell(c.value(row))).join(',')));
  return lines.join('\r\n');
};

// "﻿" (BOM) makes Excel read the file as UTF-8 so names with accents survive.
export const downloadCsv = (filename, text) => {
  const blob = new Blob([`﻿${text}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
